import { render, staticRenderFns } from "./other-properties.vue?vue&type=template&id=56823881"
import script from "./other-properties.vue?vue&type=script&lang=js"
export * from "./other-properties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports